import { TIPTAP_ACTION_BUTTON_TYPE, TIPTAP_LINK_BUTTON_TYPE } from "./../ricos-content/index.js";
import { Node_Type, PluginContainerData_Alignment } from "./../ricos-schema/legacy/wix/rich_content/v1/index.js";
import { fromTiptapLinkConverter } from "./../_shared/link/link-converters.js";
const toTiptapButtonConvert = (node) => ({
  type: node.buttonData.type === "LINK" ? TIPTAP_LINK_BUTTON_TYPE : TIPTAP_ACTION_BUTTON_TYPE,
  attrs: {
    ...node.buttonData,
    styles: {
      ...node.buttonData.styles,
      border: void 0,
      colors: void 0,
      backgroundColor: node.buttonData.styles?.backgroundColor ?? node.buttonData.styles?.colors?.background,
      textColor: node.buttonData.styles?.textColor ?? node.buttonData.styles?.colors?.text,
      borderColor: node.buttonData.styles?.borderColor ?? node.buttonData.styles?.colors?.border,
      borderWidth: node.buttonData.styles?.borderWidth ?? node.buttonData.styles?.border?.width,
      borderRadius: node.buttonData.styles?.borderRadius ?? node.buttonData.styles?.border?.radius
    },
    id: node.id
  }
});
const fromTiptapButtonConvert = (node) => {
  const { id, ...data } = node.attrs || {};
  const linkData = data.link;
  const containerData = data.containerData;
  return {
    type: Node_Type.BUTTON,
    id,
    nodes: [],
    buttonData: {
      ...data,
      link: fromTiptapLinkConverter(linkData),
      containerData: {
        ...containerData,
        alignment: containerData?.alignment || PluginContainerData_Alignment.CENTER,
        width: containerData?.width ? {
          ...containerData?.width,
          size: containerData?.width?.custom ? void 0 : containerData?.width?.size
        } : void 0
      },
      text: data.text || ""
    }
  };
};
const linkButtonConverter = {
  toPm: {
    types: [Node_Type.BUTTON],
    // @ts-ignore $TSFixMe
    convert: toTiptapButtonConvert
  },
  fromPm: {
    types: [TIPTAP_LINK_BUTTON_TYPE],
    convert: fromTiptapButtonConvert
  }
};
const actionButtonConverter = {
  toPm: {
    types: [Node_Type.BUTTON],
    // @ts-ignore $TSFixMe
    convert: toTiptapButtonConvert
  },
  fromPm: {
    types: [TIPTAP_ACTION_BUTTON_TYPE],
    convert: fromTiptapButtonConvert
  }
};
export {
  actionButtonConverter,
  linkButtonConverter
};
//# sourceMappingURL=button-converters.js.map
